import { format, isAfter, isValid, parse, startOfDay } from 'date-fns';

const PST_TIMEZONE = 'America/Los_Angeles';

/**
 * Returns the current date in US Pacific timezone (PST/PDT) at start of day.
 */
export const getCurrentDateInPST = (): Date => {
  const now = new Date();
  const pstDateString = now.toLocaleString('en-US', { timeZone: PST_TIMEZONE });
  const pstDate = new Date(pstDateString);
  return startOfDay(pstDate);
};

/**
 * Returns today's date in PST formatted as MM/DD/YYYY for DateFieldString maxDate prop.
 */
export const getTodayInPSTFormatted = (): string => {
  return format(getCurrentDateInPST(), 'MM/dd/yyyy');
};

/**
 * Checks if a given date is after today in PST timezone.
 */
export const isFutureDateInPST = (date: string | Date | null | undefined): boolean => {
  if (!date) return false;

  let inputDate: Date | undefined;

  if (date instanceof Date) {
    inputDate = date;
  } else {
    // Try parsing MM/DD/YYYY format first, then YYYY-MM-DD
    const formats = ['MM/dd/yyyy', 'yyyy-MM-dd'];
    for (const fmt of formats) {
      const parsed = parse(date, fmt, new Date());
      if (isValid(parsed) && !isNaN(parsed.getTime())) {
        inputDate = parsed;
        break;
      }
    }
  }

  if (!inputDate || !isValid(inputDate)) return false;

  const todayInPST = getCurrentDateInPST();
  return isAfter(startOfDay(inputDate), todayInPST);
};
